import { CalendarGridDayPopoverTrigger } from '../../../../CalendarGridDayPopoverTrigger'
import { CalendarGridWeekBlock } from '../../../CalendarGridWeekBlock'

import { getCalendarGridWeekGroupMoreLabel } from './CalendarGridWeekGroupMore.utils'

function CalendarGridWeekGroupMore({
  blockProps,
  day,
  items,
  moreCount,
  onClickItem,
  onClickSecondaryLabel,
}) {
  return (
    <CalendarGridDayPopoverTrigger
      Trigger={CalendarGridWeekBlock}
      day={day}
      items={items}
      triggerProps={{
        ...blockProps,
        timeLabel: getCalendarGridWeekGroupMoreLabel(moreCount),
      }}
      onClickItem={onClickItem}
      onClickSecondaryLabel={onClickSecondaryLabel}
    />
  )
}

export default CalendarGridWeekGroupMore
